import {
  AssetHealth,
  IgnitionMinimum,
  useGetHealthAssetsQuery,
} from '@customer/store/apis/healthApi';
import styles from './AssetHealthCards.module.scss';
import { useAppSelector } from '@customer/store/hooks';
import AssetHealthCardSmall from '../asset-health-card-small/AssetHealthCardSmall';
import { useTranslation } from 'react-i18next';
import { FaultLevel } from '@customer/store/slices/globalSlice';
import { NoResults } from '@dmc/ui';

interface AssetHealthCardsProps {
  faultLevel?: FaultLevel;
  limit?: number;
}

export function AssetHealthCards({
  faultLevel = FaultLevel.One,
  limit = 12,
}: AssetHealthCardsProps) {
  const { t } = useTranslation();

  const siteId = useAppSelector(state => state.auth.siteId);

  const { data: assets, isLoading } = useGetHealthAssetsQuery(
    {
      query: {
        faultLevel,
        ignitionMinimum: IgnitionMinimum.OneHour,
      },
    },
    { refetchOnMountOrArgChange: 60, skip: typeof siteId === 'undefined' },
  );

  const faultLevelIndex = Number(faultLevel) - 1;
  const filterAssetsWithFaults = (asset: AssetHealth) =>
    asset.fa[faultLevelIndex] + asset.fc[faultLevelIndex] > 0;
  const assetsWithFaults = assets?.assets?.length
    ? assets.assets.filter(filterAssetsWithFaults)
    : [];
  const sortedAssets = assetsWithFaults.sort(
    (a: AssetHealth, b: AssetHealth) => b.fa[faultLevelIndex] - a.fa[faultLevelIndex],
  );
  const topAssets = limit > 0 ? sortedAssets.slice(0, limit) : sortedAssets;

  return topAssets.length ? (
    <div className={styles.cards}>
      {topAssets.map(asset => (
        <AssetHealthCardSmall key={asset.id} asset={asset} faultLevel={faultLevel} />
      ))}
    </div>
  ) : (
    <NoResults
      description={isLoading ? t('Loading') : t('NoAssetsWithLevelFaults', { level: faultLevel })}
      height="300px"
    />
  );
}

export default AssetHealthCards;
